// extracted by mini-css-extract-plugin
module.exports = {"likes":"TotalLikes_likes__1ogKl"};